export const getCurrencySymbol = (currency?: string): string => {
  return currency === 'NPR' ? 'Rs.' : '$';
};
